<script setup lang="ts">
import { APIRoutes } from '~/types'
const isDraftModeEnabled = useDraftMode()

async function handleClick() {
  let response: Response

  if (isDraftModeEnabled) {
    response = await fetch(APIRoutes.DRAFT_MODE.DISABLE)
  } else {
    const token = prompt('To enter Draft Mode, you need to insert the NUXT_SECRET_API_TOKEN:', '')
    if (!token) {
      return
    }

    response = await fetch(`${APIRoutes.DRAFT_MODE.ENABLE}?token=${token}`)
  }

  if (!response.ok) {
    alert('Could not complete the operation!')
    return
  }

  document.location.reload()
}
</script>

<template>
  <div class="fixed bottom-3 left-3 z-50 rounded-md bg-white px-3 py-[7px] text-black">
    <button type="button" class="flex items-center gap-1 text-xs" @click="handleClick">
      <span class="flex shrink-0 items-center gap-3">
        <PulseDot :color="isDraftModeEnabled ? 'bg-success' : 'bg-error'" />
        <span>Live updates: {{ isDraftModeEnabled ? 'ON' : 'OFF' }}</span>
      </span>
    </button>
  </div>
</template>
